/**
 * Map a contract `category` string to the corresponding generic
 * SVG logo asset URL. Returns the fallback `_generic.svg` when no
 * specific category match exists.
 *
 * 03/06/2026 — Created to give an identity to anonymous contracts
 * (no `clientId` mapped to RECURRENT_CLIENTS) per contract category.
 *
 * @param {string} category - one of the contract categories from
 *   `data/contracts.js` (e.g. 'Messagerie / Colis', 'BTP / Matériaux').
 * @returns {string} public URL to the SVG logo.
 */
const CATEGORY_LOGO = {
  'Messagerie / Colis': '/client-logos/_generic-messagerie.svg',
  'BTP / Matériaux':    '/client-logos/_generic-btp.svg',
  'Frigorifique':       '/client-logos/_generic-frigorifique.svg',
  'Vrac / Palettes':    '/client-logos/_generic-vrac.svg',
  'Spécialisé':         '/client-logos/_generic-specialise.svg',
  'Export EU':          '/client-logos/_generic-export-eu.svg',
  'Export Extra-UE':    '/client-logos/_generic-export-extra-ue.svg',
  'RSE / Marchés publics': '/client-logos/_generic-rse.svg',
};

export const DEFAULT_GENERIC_LOGO = '/client-logos/_generic.svg';

export function getGenericLogoForCategory(category) {
  if (!category) return DEFAULT_GENERIC_LOGO;
  return CATEGORY_LOGO[category] || DEFAULT_GENERIC_LOGO;
}

export { CATEGORY_LOGO };
